export default __webpack_public_path__ + "static/callahan-capital-partners-61fd1e4a2f2aba2fa4434feaea919862.png";